module.exports = __webpack_public_path__ + "img/bg1.04562af5.jpg";